import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CalendarDays, ArrowLeft } from 'lucide-react';
import Navbar from '../../../../../components/navbar/Navbar';
import Footer from '../../../../../components/footer/Footer';
import SocialMediaPanel from '../../../../../components/common/social-media/SocialMediaPanel';
import { BASE_URL, batchesApi } from '../../../../../api/api';
import axios from 'axios';

const UpcomingBatchesDetails = () => {
  const [courseDetails, setCourseDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch course details from API
  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}${batchesApi}/${id}`);
        setCourseDetails(response.data || {}); // fallback to empty object
      } catch (err) {
        setError("Course not found!");
      } finally {
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [id]);

  if (loading) {
    return <div className="blog-details-error"><h2>Loading...</h2></div>;
  }

  if (error || !courseDetails) {
    return (
      <div className="blog-details-error">
        <h2 className="blog-details-error-title">{error || "Course not found!"}</h2>
        <button className="blog-details-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Go Back
        </button>
      </div>
    );
  }

  // Safe replace method for HTML content
  const safeReplace = (html) => {
    if (typeof html !== "string") return "";
    let s = html;
    s = s.replace(/<\/\?(script|style)[^>]*>/gi, "");
    s = s.replace(/\s+on[a-z]+\s*"/gi, "");
    s = s.replace(/\s*(href|src|action)\s*=\s*"[^"]*javascript:/gi, "");
    return s;
  };

  return (
    <>
      
       
      <div className="blog-details-wrapper">
        {/* Hero Section */}
        <div className="blog-details-hero">
          <img
            src={courseDetails?.image || './assets/current-affair-details-bg.jpg'}
            alt={courseDetails?.title || "Course"}
            className="blog-details-hero-image"
          />
          <div className="blog-details-hero-overlay"></div>
          <div className="blog-details-hero-content">
            <h1 className="blog-details-title">{courseDetails?.title || "Untitled Course"}</h1>
            <div className="blog-details-meta">
              <span className="blog-details-meta-item">
                <CalendarDays size={18} />{" "}
                {courseDetails?.created_at
                  ? new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(courseDetails.created_at))
                  : "Unknown Date"}
              </span>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="blog-details-content-wrapper">
          <div
            className="blog-details-content"
            dangerouslySetInnerHTML={{
              __html: safeReplace(courseDetails?.description),
            }}
          ></div>
        </div>
      </div>

      
    </>
  );
};

export default UpcomingBatchesDetails;
